import React, { useState } from 'react';
import PropTypes from "prop-types";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const DialogContext = React.createContext();

const DialogProvider = (props) => {
  const [options, setOptions] = useState(false);

  const handleClickOpen = (options) => {
    setOptions(options);
  };

  const handleClose = () => {
    setOptions(null);
  };

  const handleAccept = () => {
    if (typeof options?.acceptBtnCallback === 'function')
      options.acceptBtnCallback();
    handleClose();
  }

  const handleReject = () => {
    if (typeof options?.rejectBtnCallback === 'function')
      options.rejectBtnCallback();
    handleClose();
  }

  const renderContent = () => {
    if (options?.content)
      return options?.content;

    return options?.contentText && (
      <DialogContentText id="alert-dialog-description">
        {options.contentText}
      </DialogContentText>
    )
  };

  return (
    <DialogContext.Provider
      value={{
        actions: { open: handleClickOpen, close: handleClose }
      }}
    >
      {props.children}
      <Dialog
        open={!!options}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {
          options?.title && (
            <DialogTitle id="alert-dialog-title">
              {options.title}
            </DialogTitle>
          )
        }
        <DialogContent>
          {
            renderContent()
          }
        </DialogContent>
        <DialogActions>
          {
            options?.rejectBtnText && (
              <Button onClick={handleReject} color="primary">
                {options.rejectBtnText}
              </Button>
            )
          }
          {
            options?.acceptBtnText && (
              <Button onClick={handleAccept} color="primary" autoFocus>
                {options.acceptBtnText}
              </Button>
            )
          }
        </DialogActions>
      </Dialog>
    </DialogContext.Provider>
  );
};

DialogContext.propTypes = {
  children: PropTypes.element,
};

export { DialogProvider, DialogContext };